"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bankSlipSave = bankSlipSave;
exports.bankSlipSaveKR = bankSlipSaveKR;
exports.invoicingApplicationSave = invoicingApplicationSave;
exports.openDialog = openDialog;
exports.openDialogKR = openDialogKR;
exports.openDialogSHK = openDialogSHK;
exports.saveBankInvoiceSHK = saveBankInvoiceSHK;
exports.saveBankInvoiceSHKSupply = saveBankInvoiceSHKSupply;
exports.search = search;
exports.searchInvoice = searchInvoice;
exports.searchInvoiceShk = searchInvoiceShk;
exports.setDownloadFile = setDownloadFile;
exports.updateFeeState = updateFeeState;
var _request = _interopRequireDefault(require("@/utils/request"));
//出口费用确认及水单上传-查询
function search(data) {
  return (0, _request.default)({
    url: "/ebusiness/docFeesStateList/search",
    method: 'post',
    data: data
  });
}
//出口费用确认及水单上传-费用确认
function updateFeeState(data) {
  return (0, _request.default)({
    url: "/ebusiness/docFeesStateList/updateFeeState",
    method: 'post',
    data: data
  });
}
//出口费用确认及水单上传-费率折算
function openDialog(data) {
  return (0, _request.default)({
    url: "/ebusiness/docFeesStateList/openDialog",
    method: 'post',
    data: data
  });
}
//出口费用确认及水单上传-费率折算（韩国KR）
function openDialogKR(data) {
  return (0, _request.default)({
    url: "/ebusiness/feeConfirm/openDialog",
    method: 'post',
    data: data
  });
}
//出口费用确认及水单上传-水单上传
function bankSlipSave(data) {
  return (0, _request.default)({
    url: "/ebusiness/docFeesStateList/bankSlipSave",
    method: 'post',
    data: data
    // headers: {
    //   'Content-Type': 'multipart/form-data'
    // }
  });
}
//出口费用确认及水单上传-水单上传（韩国KR）
function bankSlipSaveKR(data) {
  return (0, _request.default)({
    url: "/ebusiness/feeConfirm/bankSlipSaveKr",
    method: 'post',
    data: data
    // headers: {
    //   'Content-Type': 'multipart/form-data'
    // }
  });
}
//出口费用确认及水单上传-开票申请保存
function invoicingApplicationSave(data) {
  return (0, _request.default)({
    url: "/ebusiness/docFeesStateList/invoicingApplicationSave",
    method: 'post',
    data: data
  });
}

//出口费用确认及水单上传-开票申请对话框加载
function searchInvoice(data) {
  return (0, _request.default)({
    url: "/ebusiness/docFeesStateList/searchInvoice",
    method: 'post',
    data: data
  });
}
//出口费用确认及水单上传-开票申请对话框加载蛇口
function openDialogSHK(amountStr, idBlNos) {
  return (0, _request.default)({
    url: "/ebusiness/feeConfirm/openDialogSHK?amountStr=".concat(amountStr, "&idBlNos=").concat(idBlNos),
    method: 'post'
  });
}
//出口费用确认及水单上传-查询开票信息(蛇口)
function searchInvoiceShk(blNos) {
  return (0, _request.default)({
    url: "/ebusiness/feeConfirm/searchInvoiceShk?blNos=".concat(blNos),
    method: 'get'
  });
}

//出口费用确认及水单上传-水单上传/开票申请(蛇口)
function saveBankInvoiceSHK(data) {
  return (0, _request.default)({
    url: "/ebusiness/feeConfirm/saveBankInvoiceSHK",
    method: 'post',
    data: data
  });
}
//出口费用确认及水单上传-已开票补传水单保存
function saveBankInvoiceSHKSupply(data) {
  return (0, _request.default)({
    url: "/ebusiness/feeConfirm/uploadBankSlipSHK",
    method: 'post',
    data: data
  });
}
//下载文件
function setDownloadFile(url) {
  return (0, _request.default)({
    responseType: 'blob',
    url: url,
    method: 'get'
  });
}